import React, { Component } from "react";
import { Button, Paper } from "@material-ui/core";

import {
  getFirestoreDocument,
  updateFirestoreDocument,
  firebaseLogin,
  firebaseLogout,
  isFirebaseAuthenticated,
} from "../../firebase/firebase";

import { NotificationManager } from "react-notifications";
import Loader from "../../../../loader";

export default class OfferInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ==========================================
      // GENERAL
      // ==========================================

      isLoaded: false,

      // ==========================================
      // FIREBASE AUTHENTICATION
      // ==========================================

      firebaseAuthenticated: false,

      firebaseAuthenticating: true,

      firebaseEmail:
        "jccreationsbusiness@gmail.com",

      // IMPORTANT:
      // Do NOT put your real password here.
      //
      // If your firebase.js already contains
      // the authentication credentials, keep
      // the password there.
      firebasePassword: "",

      // ==========================================
      // OFFER
      // ==========================================

      title: "",

      english: "",

      telugu: "",

      status: false,
    };
  }

  componentDidMount() {
    this.initializeAuthentication();
  }

  // =====================================================
  // AUTOMATIC FIREBASE AUTHENTICATION
  // =====================================================

  initializeAuthentication = async () => {
    this.setState({
      firebaseAuthenticating: true,
      firebaseAuthenticated: false,
    });

    try {
      // -------------------------------------------------
      // If an existing Firebase authentication session
      // already exists, use it.
      // -------------------------------------------------

      if (isFirebaseAuthenticated()) {
        this.setState({
          firebaseAuthenticated: true,
          firebaseAuthenticating: false,
        });

        await this.loadOffer();

        return;
      }

      // -------------------------------------------------
      // AUTOMATIC LOGIN
      //
      // firebaseLogin() should use the credentials
      // configured in firebase.js.
      // -------------------------------------------------

      await firebaseLogin(
        this.state.firebaseEmail,
        this.state.firebasePassword
      );

      // -------------------------------------------------
      // AUTHENTICATION SUCCESS
      // -------------------------------------------------

      this.setState({
        firebaseAuthenticated: true,
        firebaseAuthenticating: false,
      });

      await this.loadOffer();

    } catch (error) {
      console.error(
        "Automatic Firebase authentication error:",
        error
      );

      firebaseLogout();

      this.setState({
        firebaseAuthenticated: false,
        firebaseAuthenticating: false,
        isLoaded: false,
      });

      NotificationManager.error(
        "Firebase authentication failed. Configuration is locked.",
        "Authentication Error"
      );
    }
  };

  // =====================================================
  // LOAD OFFER
  // =====================================================

  loadOffer = async () => {
    this.setState({
      isLoaded: true,
    });

    try {
      const data =
        await getFirestoreDocument(
          "offer",
          "offer"
        );

      const fields =
        data.fields || {};

      this.setState({
        title:
          fields.title &&
          fields.title.stringValue
            ? fields.title.stringValue
            : "",

        english:
          fields.english &&
          fields.english.stringValue
            ? fields.english.stringValue
            : "",

        telugu:
          fields.telugu &&
          fields.telugu.stringValue
            ? fields.telugu.stringValue
            : "",

        status:
          fields.status &&
          fields.status.booleanValue === true,

        isLoaded: false,
      });

    } catch (error) {
      console.error(
        "Error loading offer:",
        error
      );

      this.setState({
        isLoaded: false,
      });

      NotificationManager.error(
        "Unable to load offer information",
        "Error"
      );
    }
  };

  // =====================================================
  // HANDLE CHANGE
  // =====================================================

  handleChange = (e) => {
    const {
      name,
      value,
    } = e.target;

    this.setState({
      [name]:
        name === "status"
          ? value === "true"
          : value,
    });
  };

  // =====================================================
  // BACK
  // =====================================================

  handleBack = () => {
    this.props.history.goBack();
  };

  // =====================================================
  // UPDATE OFFER
  // =====================================================

  handleSubmit = async () => {
    // =================================================
    // SECURITY CHECK
    // =================================================

    if (!isFirebaseAuthenticated()) {
      this.setState({
        firebaseAuthenticated: false,
      });

      NotificationManager.error(
        "Authentication is required before updating.",
        "Authentication Required"
      );

      return;
    }

    const {
      title,
      english,
      telugu,
      status,
    } = this.state;

    // =================================================
    // VALIDATION
    // =================================================

    if (!title.trim()) {
      NotificationManager.error(
        "Offer title is required",
        "Input Error"
      );

      return;
    }

    if (!english.trim()) {
      NotificationManager.error(
        "English offer information is required",
        "Input Error"
      );

      return;
    }

    if (!telugu.trim()) {
      NotificationManager.error(
        "Telugu offer information is required",
        "Input Error"
      );

      return;
    }

    this.setState({
      isLoaded: true,
    });

    try {
      // =================================================
      // UPDATE FIRESTORE
      // =================================================

      await updateFirestoreDocument(
        "offer",
        "offer",
        {
          title: {
            stringValue:
              title.trim(),
          },

          english: {
            stringValue:
              english.trim(),
          },

          telugu: {
            stringValue:
              telugu.trim(),
          },

          status: {
            booleanValue:
              status === true,
          },
        }
      );

      this.setState({
        isLoaded: false,
      });

      NotificationManager.success(
        "Offer information updated successfully",
        "Offer Updated"
      );

      await this.loadOffer();

    } catch (error) {
      console.error(
        "Error updating offer:",
        error
      );

      this.setState({
        isLoaded: false,
      });

      // =================================================
      // FIRESTORE PERMISSION ERROR
      // =================================================

      if (
        (error.message &&
          error.message.includes(
            "PERMISSION_DENIED"
          )) ||
        (error.message &&
          error.message.includes(
            "permission"
          ))
      ) {
        firebaseLogout();

        this.setState({
          firebaseAuthenticated: false,
        });

        NotificationManager.error(
          "Authentication expired or you do not have permission to update this configuration.",
          "Permission Denied"
        );

        return;
      }

      NotificationManager.error(
        error &&
        error.message
          ? error.message
          : "Unable to update offer information",
        "Error"
      );
    }
  };

  // =====================================================
  // RENDER
  // =====================================================

  render() {
    const {
      isLoaded,
      title,
      english,
      telugu,
      status,
      firebaseAuthenticated,
      firebaseAuthenticating,
    } = this.state;

    const configurationEnabled =
      firebaseAuthenticated &&
      !firebaseAuthenticating;

    return (
      <div className="container-fluid">

        {/* ==========================================
            HEADER
        ========================================== */}

        <div className="row">

          <div className="col-lg-5 col-md-9">

            <h2 className="mt-30 page-title">
              Offer Configuration
            </h2>

          </div>

          <div className="col-lg-5 col-md-3 back-btn">

            <Button
              variant="contained"
              onClick={
                this.handleBack
              }
            >
              <i className="fas fa-arrow-left" />
              {" "}
              Back
            </Button>

          </div>

        </div>

        {/* ==========================================
            BREADCRUMB
        ========================================== */}

        <ol className="breadcrumb mb-30">

          <li className="breadcrumb-item">
            Dashboard
          </li>

          <li className="breadcrumb-item">
            Offer
          </li>

          <li className="breadcrumb-item active">
            Configuration
          </li>

        </ol>

        {/* ==========================================
            FORM
        ========================================== */}

        <Paper
          className="user-management"
          style={{
            padding: "1.5rem",
            marginBottom: "50px",
          }}
        >

          {isLoaded && (
            <Loader />
          )}

          {/* =====================================================
              FIREBASE AUTHENTICATION STATUS
          ===================================================== */}

          <div
            style={{
              marginBottom: "30px",
              padding: "20px",
              borderRadius: "10px",

              border:
                configurationEnabled
                  ? "1px solid #28a745"
                  : "1px solid #dee2e6",

              background:
                configurationEnabled
                  ? "#f0fff4"
                  : "#f8f9fa",
            }}
          >

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >

              <div>

                <h5
                  style={{
                    margin: 0,
                    fontWeight: "600",
                  }}
                >
                  Configuration Authentication
                </h5>

                <small className="text-muted">

                  {firebaseAuthenticating
                    ? "Authenticating securely. Please wait..."
                    : configurationEnabled
                      ? "Authentication verified. You can now update the Offer configuration."
                      : "Authentication failed. Configuration is locked."}

                </small>

              </div>

              {/* ======================================
                  AUTHENTICATING
              ====================================== */}

              {firebaseAuthenticating && (

                <span
                  style={{
                    background: "#ffc107",
                    color: "#212529",
                    padding: "6px 12px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >

                  <i className="fas fa-spinner fa-spin mr-1" />

                  AUTHENTICATING

                </span>

              )}

              {/* ======================================
                  AUTHENTICATED
              ====================================== */}

              {!firebaseAuthenticating &&
                firebaseAuthenticated && (

                  <span
                    style={{
                      background: "#28a745",
                      color: "#fff",
                      padding: "6px 12px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >

                    <i className="fas fa-check-circle mr-1" />

                    AUTHENTICATED

                  </span>

                )}

              {/* ======================================
                  FAILED
              ====================================== */}

              {!firebaseAuthenticating &&
                !firebaseAuthenticated && (

                  <span
                    style={{
                      background: "#dc3545",
                      color: "#fff",
                      padding: "6px 12px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >

                    <i className="fas fa-times-circle mr-1" />

                    NOT AUTHENTICATED

                  </span>

                )}

            </div>

          </div>

          {/* =====================================================
              OFFER CONFIGURATION
          ===================================================== */}

          <div
            style={{
              opacity:
                configurationEnabled
                  ? 1
                  : 0.55,

              transition:
                "opacity 0.2s ease",
            }}
          >

            <div className="row">

              {/* ======================================
                  TITLE
              ====================================== */}

              <div className="col-md-12 form-group">

                <label
                  style={{
                    fontWeight: "600",
                  }}
                >
                  Offer Title
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={title}
                  onChange={
                    this.handleChange
                  }
                  placeholder="Enter offer title"
                  disabled={
                    !configurationEnabled
                  }
                />

                <small className="text-muted">
                  Main title displayed for the offer.
                </small>

              </div>

              {/* ======================================
                  ENGLISH
              ====================================== */}

              <div className="col-md-12 form-group">

                <label
                  style={{
                    fontWeight: "600",
                  }}
                >
                  English Offer
                </label>

                <textarea
                  className="form-control"
                  name="english"
                  value={english}
                  onChange={
                    this.handleChange
                  }
                  placeholder="Enter English offer information"
                  rows="4"
                  disabled={
                    !configurationEnabled
                  }
                />

                <small className="text-muted">
                  Offer message displayed in English.
                </small>

              </div>

              {/* ======================================
                  TELUGU
              ====================================== */}

              <div className="col-md-12 form-group">

                <label
                  style={{
                    fontWeight: "600",
                  }}
                >
                  Telugu Offer
                </label>

                <textarea
                  className="form-control"
                  name="telugu"
                  value={telugu}
                  onChange={
                    this.handleChange
                  }
                  placeholder="Enter Telugu offer information"
                  rows="4"
                  disabled={
                    !configurationEnabled
                  }
                />

                <small className="text-muted">
                  Offer message displayed in Telugu.
                </small>

              </div>

              {/* ======================================
                  STATUS
              ====================================== */}

              <div className="col-md-6 form-group">

                <label
                  style={{
                    fontWeight: "600",
                  }}
                >
                  Offer Status
                </label>

                <select
                  className="form-control"
                  name="status"
                  value={String(status)}
                  onChange={
                    this.handleChange
                  }
                  disabled={
                    !configurationEnabled
                  }
                >

                  <option value="true">
                    Active
                  </option>

                  <option value="false">
                    Inactive
                  </option>

                </select>

                <small className="text-muted">
                  Active = Offer is enabled
                  {" | "}
                  Inactive = Offer is disabled
                </small>

              </div>

            </div>

            {/* ==========================================
                UPDATE BUTTON
            ========================================== */}

            <button
              type="button"
              className="btn btn-primary col-sm-3 mt-3 py-2"
              onClick={
                this.handleSubmit
              }
              disabled={
                isLoaded ||
                !configurationEnabled
              }
            >

              <i className="fas fa-save mr-2" />

              Update Offer

            </button>

          </div>

        </Paper>

        {/* ==========================================
            BOTTOM SPACING
        ========================================== */}

        <div
          style={{
            height: "60px",
          }}
        />

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/admin/view/offer/view/index.js